module.exports = __webpack_public_path__ + "img/report-unscramble-bg-2.f6f71076.png";